import { render, staticRenderFns } from "./OfertaSubastasForm.vue?vue&type=template&id=39c5c1a7"
import script from "./OfertaSubastasForm.vue?vue&type=script&lang=js"
export * from "./OfertaSubastasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports